import { render, staticRenderFns } from "./identifier.vue?vue&type=template&id=5f5c9ad1&scoped=true"
import script from "./identifier.vue?vue&type=script&lang=js"
export * from "./identifier.vue?vue&type=script&lang=js"
import style0 from "./identifier.vue?vue&type=style&index=0&id=5f5c9ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c9ad1",
  null
  
)

export default component.exports